module.exports = __webpack_public_path__ + "site/img/team_member_sign_2.4188c9da.png";